<template>
  <el-dialog
    title="IP设置"
    v-model="isShowIP"
    width="40%"
    center
    :close-on-click-modal="false"
    @closed="dialogClosedHandle"
  >
    <div class="page_warp">
      <div class="input_row">
        <div class="input_lable">白名单开关：</div>
        <div class="input_box">
          <el-switch
            v-model="userWhiteSwitchStatus"
            active-text="正常"
            inactive-text="禁用"
          >
          </el-switch>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">IP白名单：</div>
        <div class="input_box">
          <el-input
            placeholder="请输入IP"
            type="textarea"
            :rows="3"
            v-model="dataItem.ipAddrStr"
            show-word-limit
            字数限制遮挡文本
            resize="none"
            文本域鼠标不可拖拉
          />
        </div>
      </div>

      <div class="footer_btn_warp">
        <div class="cancle_btn" @click="closeModal()">取消</div>
        <div class="confirm_btn" @click="submit()">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  nextTick,
} from "vue";
import { imgFileToBase64, isPhone, isIdNo } from "@/libs/tools";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default defineComponent({
  name: "IPSet",
  emits: ["getData"],
  setup(props, context) {
    const store = useStore();
    const { proxy } = getCurrentInstance();

    const getData = () => {
      context.emit("getData");
    };
    onMounted(() => {
      nextTick(() => {});
    });
    const data = reactive({
      isShowIP: false,
      userWhiteSwitchStatus: true,
      dataItem: {
        userWhiteSwitch: "",
        ipAddrStr: "",
        setUserId: "",
      },
    });
    //重置数据
    const init = (id) => {
      data.isShowIP = true;
      data.dataItem.setUserId=id
      getInfo()
    };
    const getInfo=async()=>{
      let params={
        userId:data.dataItem.setUserId,
      }
      const r=await proxy.$http.get(apiObj.userIP,params)
      if(r.code===0||r.respCode==='0000'){
        data.dataItem.ipAddrStr=r.data.ipAddrStr
        data.dataItem.userWhiteSwitch=r.data.userWhiteSwitch
        data.userWhiteSwitchStatus=r.data.userWhiteSwitch=='Y'?true:false
      }

    }
    const dialogClosedHandle = () => {
      data.isShowIP = false;
    };
    const closeModal = () => {
      data.isShowIP = false;
    };
    const submit=async()=>{
      data.dataItem.userWhiteSwitch= data.userWhiteSwitchStatus?"Y":"N"
      let params={
        userId:data.dataItem.setUserId,
        ipAddrStr:data.dataItem.ipAddrStr,
        userWhiteSwitch:data.dataItem.userWhiteSwitch
      }
      const r=await proxy.$http.props(apiObj.userIPSave,params)
      if(r.code===0||r.respCode==='0000'){
        proxy.$message.success(r.msg || r.respMsg);
        data.isShowIP=false
      }else{
        proxy.$message.error(r.msg || r.respMsg);
      }
    };

    return {
      ...toRefs(data),
      init,
      getInfo,
      closeModal,
      getData,
      dialogClosedHandle,
      submit
    };
  },
});
</script>
<style scoped>
.page_warp {
  width: 100%;
  max-height: 600px;
}
.input_row {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}
.input_img_row {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
}
.input_lable {
  width:110px;
  text-align: right;
}
.input_box {
  width: 50%;
}
.input_tree_warp {
  width: calc(100% - 30px);
  height: 300px;
  margin-left: 30px;

  box-sizing: border-box;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.manage {
  width: 48%;
  height: 100%;

  display: flex;
}
.tree {
  width: calc(100% - 80px);
  height: 100%;
  overflow: auto;
}
.footer_btn_warp {
  width: 100%;
  height: 70px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancle_btn {
  width: 116px;
  height: 38px;
  background: #e36a19;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
  margin-right: 90px;
}
.confirm_btn {
  width: 116px;
  height: 38px;
  background: #293787;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
}
:deep(.el-select) {
  width: 100%;
}
.selectTree {
  position: relative;
  cursor: pointer;
}
:deep(.selectTree .el-input__inner) {
  cursor: pointer !important;
}
.tree_warp {
  width: 100%;
  height: 200px;
  border: 1px solid #e4e7ed;
  position: absolute;
  left: 0;
  bottom: -205px;
  overflow: auto;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.tree_warp::-webkit-scrollbar {
  width: 3px;
}

.tree_warp::-webkit-scrollbar-thumb {
  background: #e4e7ed;
  border-radius: 20px;
  opacity: 0.3;
}
.transform180 {
  transform: rotate(180deg);
}
</style>
